import React, {useRef} from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import {TextField} from "@material-ui/core";
import {withStyles} from "@material-ui/styles";
import theme from "../../../styles/theme";

const CustomTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
    },
    "& label": {
      color: theme.input.colors.secondary,
    },
    "& label.Mui-focused": {
      color: theme.input.colors.secondary,
    },
    "& .MuiInputBase-input": {
      color: theme.input.colors.primary,
    },
  },
})(TextField);

function Input({ name, label, ...props }) {
  const inputRef = React.useRef(null);
  const materialInputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  React.useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: props.multiline ? 'value' : 'value',
      setValue(ref, value) {
        if (props.multiline && materialInputRef.current) {
          const textarea = materialInputRef.current.querySelector('textarea');
          if (textarea) {
            textarea.value = value;
          }
        } else {
          ref.value = value;
        }

        if (materialInputRef.current) {
          const label = materialInputRef.current.querySelector("label");
          if (label) {
            label.classList.add("MuiFormLabel-filled", "MuiInputLabel-shrink");
          }
        }
      }
    });
  }, [fieldName, registerField, props.multiline]);

  return (
      <CustomTextField
          name={fieldName}
          error={!!error}
          ref={materialInputRef}
          helperText={error ? error : null}
          inputRef={inputRef}
          defaultValue={defaultValue}
          label={label}
          fullWidth
          {...props}
      />
  );
}

export default Input;

Input.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
